import Vue from 'vue';
import VueImg from 'v-img';
import Vuetify from 'vuetify/lib';

Vue.use(VueImg);
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    light: true,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        accent: '#6EC6D8',
        primary: '#65696B',
      },
      light: {
        accent: '#6EC6D8',
        primary: '#65696B',
      },
    },
  },
});
